import { WhiteLabelPdfGendersStatistics, WhiteLabelTotalWithAverageSessions, WhiteLabelUsersCommentsWithRate } from 'src/app/core/data/model';
import { BlocState, ShowLoadingComponentState } from 'src/app/shared/bloc/base-bloc';

export class StatisticsState extends BlocState {}

export class StatisticsChartReadyState extends StatisticsState {
  constructor(public statistics: WhiteLabelTotalWithAverageSessions) {
    super();
  }
}

export class StatisticsReadyPDFState extends StatisticsState {
  constructor( public statistics: WhiteLabelPdfGendersStatistics ) {
    super();
  }
}

export class StatisticsCommentsReadyState extends StatisticsState {
  constructor( public comments: WhiteLabelUsersCommentsWithRate) {
    super();
  }
}


export class StatisticsCommentsLoadingState extends StatisticsState {
  constructor() {
    super();
  }
}

